import $axios from '@/api/apiPublic';

const getRatingBrokers = async () => {
  const response = await $axios.get('broker/forex?limit=20&offset=0');
  // const response = await $axios.get('broker/forex')
  return response;
};

const getRatingBroker = async id => {
  const response = await $axios.get(`broker/overview/${id}`);
  return response;
};

export default {
  getRatingBrokers,
  getRatingBroker,
};
